import React, { useState } from "react";  

import {  
    
    CardHomeHeaderActions,
    HeaderActions,

} from "./styled";

import Button from "components/Form/Button";

export default function DashboardActions({ actions, loading }){  

    return ( 
        <>
            <HeaderActions>
                {
                    actions?.map((item, key) => 
                        <CardHomeHeaderActions key={key}>
                            <Button outline={!!item.outline} primary onClick={item.action} loading={item.loadable && loading} width={item.width} height={item.height}>{ item.title }</Button>
                        </CardHomeHeaderActions>
                    )
                }
            </HeaderActions>
        </>
    );
}